import { ComarkClient } from "@comark/react";
import security from "@comark/react/plugins/security";
import { cn } from "@/lib/utils";

const MARKDOWN_PLUGINS = [
  security({
    blockedTags: [
      "script",
      "iframe",
      "object",
      "embed",
      "link",
      "style",
      "base",
      "meta",
    ],
    allowedProtocols: ["https", "http", "mailto"],
    allowDataImages: false,
  }),
];

type MarkdownProps = {
  markdown: string;
  className?: string;
};

export function Markdown({ markdown, className }: MarkdownProps) {
  return (
    <div className={cn("typeset typeset-docs max-w-[37em]", className)}>
      <ComarkClient markdown={markdown} plugins={MARKDOWN_PLUGINS} />
    </div>
  );
}
